import { css } from '@emotion/react';

function BackgroundGlow() {
  return <div css={styles.bgGlow} />;
}

const styles = {
  bgGlow: css`
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    pointer-events: none;

    background: radial-gradient(
      ellipse 600px 500px at 50% 15%,
      rgba(0, 180, 240, 0.35) 0%,
      rgba(20, 90, 200, 0.2) 45%,
      transparent 70%
    );
  `,
};

export default BackgroundGlow;
